import { useEffect, useRef } from "react";
import { useReducedMotion } from "framer-motion";

export const BgVideo = ({ src, poster, testId }) => {
  const reduce = useReducedMotion();
  const ref = useRef(null);
  useEffect(() => {
    const v = ref.current;
    if (!v) return;
    if (reduce) { v.pause(); } else { v.play().catch(() => {}); }
  }, [reduce]);
  if (reduce) return null;
  return (
    <video ref={ref} className="bgv" data-testid={testId} autoPlay muted loop playsInline
      preload="auto" poster={poster} src={src} aria-hidden="true" />
  );
};
